import api from '~/api'

const state = {
  offerGroup: null,
}

const getters = {
  getOfferGroupFromState: s => s.offerGroup,
}

const mutations = {
  SET_OFFER_GROUP(state, payload) {
    state.offerGroup = {
      ...state.offerGroup,
      ...payload,
    }
  },
  SET_OFFER_IN_GROUP(state, payload) {
    state.offerGroup = {
      ...state.offerGroup,
      offers: payload,
    }
  },
  SET_DEFAULT_OFFER_GROUP(state) {
    state.offerGroup = null
  },
}

const actions = {
  getAllOffers() {
    return api.get('offers?page=1&perPage=1000')
  },
  async getOffersForGroup({ commit }, id) {
    const [err, response] = await api.get(`offer-groups/${id}/offers`)

    if (response) {
      const offers = response.items.length ? response.items.map(item => `offers/${item.id}`) : []

      commit('SET_OFFER_IN_GROUP', offers)
    }

    return [err]
  },
  async getOfferGroup({ commit }, id) {
    const [err, response] = await api.get(`offer-groups/${id}`)

    if (response) {
      const { enabled, tags, startsAt, endsAt, redemptionLimit, name, id, providerId } = response

      commit('SET_OFFER_GROUP', {
        enabled, tags, startsAt, endsAt, redemptionLimit, name, id, providerId,
      })
    }
    return [err, response]
  },

  setDefaultOfferGroup({ commit }) {
    commit('SET_DEFAULT_OFFER_GROUP')
  },
  createOfferGroup(_, { data, options }) {
    return api.post('offer-groups', data, options)
  },
  updateOfferGroup(_, { data, options }) {
    return api.put(`offer-groups/${data.id}`, data, options)
  },
  deleteOfferGroup(_, id) {
    return api.delete(`offer-groups/${id}`)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
